import React from 'react';
import styles from './StaffingLevelsAvailability.module.scss';

import LevelsTable from './LevelsTable';
import LevelsBar from './LevelsBar';
import AvailabilityTable from './AvailabilityTable';
import AvailabilityCharts from './AvailabilityCharts';

import NoDataView from '../../NoDataView';

export default function StaffingLevels({ data }) {
  if (
    !data?.staffingLevelsDashboard?.staffingLevelsProjects?.length &&
    !data?.availabilityDashboard?.total &&
    data?.department?.id
  )
    return <NoDataView label="No matches in the table." />;

  if (
    !data?.staffingLevelsDashboard?.staffingLevelsProjects?.length &&
    !data?.availabilityDashboard?.total &&
    !data?.department?.id
  )
    return <NoDataView label="Set filter data to generate Staffing Levels & Availability" />;

  return (
    <div className={styles.section}>
      <LevelsTable
        dashboard={data?.staffingLevelsDashboard || {}}
        dashboardId={data.id}
        department={data?.department || {}}
      />
      <LevelsBar
        dashboard={data?.staffingLevelsDashboard || {}}
        department={data?.department || {}}
      />

      <AvailabilityTable
        dashboard={data?.availabilityDashboard || {}}
        dashboardId={data.id}
        department={data?.department || {}}
      />

      <AvailabilityCharts dashboard={data?.availabilityDashboard || {}} />
    </div>
  );
}
